<template>
	<div class="video-text-confirm-page">
		<!-- 导航栏：新增右侧下一步按钮 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">内容确认</div>
			<!-- 导航栏右侧下一步按钮 -->
			<div class="next-step-btn" @click.stop="handleNextStep">
				下一步
			</div>
		</div>

		<!-- 主体区域 -->
		<div class="page-body">
			<!-- 内容模块：标题改为“内容”，右侧三个按钮 -->
			<div class="result-section">
				<div class="section-header">
					<div class="section-title">内容</div>
					<!-- 右侧三个按钮组 -->
					<div class="confirm-btn-group">
						<div class="clear-btn" @click.stop="handleNextStep" v-if="currentPlatform == 'weixin'">
							下一步
						</div>
						<div class="clear-btn" @click="handleClear">
							清空
						</div>
						<div class="save-btn" @click="handleSaveScript">
							脚本保存
						</div>
						<div class="ai-rewrite-btn" @click="handleAiRewrite">
							<img src="@/assets/gx.svg" class="rewrite-icon" />
							<span class="rewrite-text">AI改写</span>
						</div>
					</div>
				</div>
				<!-- 文本框：保留样式，调整placeholder -->
				<textarea class="content-input" v-model="content" placeholder="已生成的口播视频文案">
				</textarea>
				<div class="word-count-tip">
					当前{{ wordCount }}个字
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		saveScript,textTime
	} from "@/api/poster";
	export default {
		name: "VideoTextConfirmPage",
		data() {
			return {
				currentPlatform: '',
				content: "" // 文案内容（可从路由参数/缓存获取）
			};
		},
		computed: {
			// 统计有效字数（去除首尾空格）
			wordCount() {
				return this.content.trim().length;
			},
			// 计算时长（3.333字/秒，向上取整更贴合实际场景）
			secondCount() {
				if (this.wordCount === 0) return 0;
				// 3.333个字=1秒，Math.ceil向上取整，也可改用Math.round四舍五入
				return Math.ceil(this.wordCount / 3.333);
			}
		},
		mounted() {
			document.title = "内容确认";
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
			// 可选：从路由参数获取生成的文案内容
			// const { content } = this.$route.query;
			// if (content) this.content = content;
			const {
				content
			} = this.$route.query;
			if (content) {
				this.content = content; // 将路由参数的content填充到data中
			}

			const rewriteContent = sessionStorage.getItem('rewriteContent');
			if (rewriteContent) {
				this.content = JSON.parse(rewriteContent); // 赋值到当前页面
				sessionStorage.removeItem('rewriteContent'); // 读取后立即删除，避免重复读取
				this.$toast('已应用AI改写内容');
			}
		},
		methods: {
			// 返回按钮
			onBack() {
				this.$router.back();
			},
			// 清空按钮逻辑
			handleClear() {
				if (!this.content.trim()) {
					this.$toast('暂无内容可清空');
					return;
				}
				this.content = "";
				this.$toast('内容已清空');
			},
			// 脚本保存按钮逻辑（接口暂空）
			async handleSaveScript() {
				if (!this.content.trim()) {
					this.$toast('请先填写/生成文案后再保存');
					return;
				}

				try {
					const res = await saveScript({
						text: this.content
					});
					console.log('请求结果', res);
					if (res) {
						this.$toast('保存成功');
					}
				} catch (error) {
					console.log(error);
				}
			},
			// AI改写按钮逻辑（接口暂空）
			handleAiRewrite() {
				if (!this.content.trim()) {
					this.$toast('请先填写文案后再进行AI改写');
					return;
				}
				this.$router.push({
					path: "videoTextrewrite",
					query: {
						content: this.content
					}
				});
			},
			// 导航栏下一步按钮逻辑
			async handleNextStep() {
				if (!this.content.trim()) {
					this.$toast('请先填写/生成文案后再继续');
					return;
				}
				
				try {
					const res = await textTime({
						text: this.content
					});
					console.log('请求结果', res);
					if(res){
						if(res > 120){
							this.$toast('文案字数太多，请减少篇幅');
						}else{
							this.$router.push({
								path: 'videoCreation',
								query: {
									text: this.content
								}
							})
						}
					}
					
				} catch (error) {
					console.log(error);
				}
				// this.$router.replace({
				// 	path: 'videoCreation',
				// 	query: {
				// 		text: this.content
				// 	}
				// })
				// this.$toast('跳转至下一步...');
				// 替换为实际跳转路径
				// this.$router.push({ path: "xxx" });
			}
		}
	};
</script>

<style scoped>
	/* 页面基础布局（与原页面一致） */
	.video-text-confirm-page {
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}

	/* 导航栏（新增右侧下一步按钮） */
	.custom-nav-bar {
		width: 100%;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 导航栏右侧下一步按钮样式 */
	.next-step-btn {
		position: absolute;
		right: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		padding: 0.8vw 2.6667vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}

	/* 主体区域：flex列布局，占满剩余高度 */
	.page-body {
		padding: 5.3333vw 4.8vw;
		box-sizing: border-box;
		background: #FFFFFF;
		flex: 1;
		min-height: 0;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	/* 结果模块通用样式 */
	.result-section {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	/* 标题/内容 头部（调整按钮组布局） */
	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1.6vw;
		flex-shrink: 0;
	}

	.section-title {
		opacity: 0.9;
		font-family: SourceHanSansSC-bold;
		color: #1F2226;
		font-weight: 700;
		font-size: 4.2667vw;
		letter-spacing: -0.1333vw;
		font-style: normal;
		text-decoration: none;
		text-align: left;
	}

	/* 右侧三个按钮组布局 */
	.confirm-btn-group {
		display: flex;
		gap: 1.6vw;
		/* 按钮间距12px */
		align-items: center;
	}

	/* 清空按钮样式 */
	.clear-btn {
		padding: 0.8vw 2.6667vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}

	/* 脚本保存按钮样式 */
	.save-btn {
		padding: 0.8vw 2.6667vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}

	/* AI改写按钮样式（复用原有样式） */
	.ai-rewrite-btn {
		padding: 0.8vw 2.4vw;
		height: 5.3333vw;
		width: auto;
		display: flex;
		align-items: center;
		gap: 0.8vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #1570EE;
		cursor: pointer;
		box-sizing: border-box;
	}

	.rewrite-icon {
		width: 2.6667vw;
		height: 2.6667vw;
		object-fit: contain;
	}

	.rewrite-text {
		font-family: SourceHanSansSC-regular;
		color: #FFFFFF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
	}

	.word-count-tip {
		margin-top: 1.6vw;
		/* 与文本框间距 */
		font-family: SourceHanSansSC-regular;
		font-size: 3.2vw;
		color: #666666;
		/* 灰色文字更柔和 */
		text-align: right;
		/* 右对齐更美观 */
		line-height: 1.2;
	}

	/* 调整content-input高度（腾出统计区域空间） */
	.content-input {
		width: 100%;
		flex: 1;
		/* 原有高度减少统计区域的占位，从21.8667vw改为24vw */
		height: calc(100% - 24vw);
		padding: 2.6667vw 3.2vw;
		border-radius: 2.1333vw;
		border: 0.2667vw solid #D2DAE4;
		box-shadow: 0px -0.2667vw 0px 0px rgba(228, 232, 236, 1);
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
		outline: none;
		resize: none;
		box-sizing: border-box;
		background: #FFFFFF;
		line-height: 1.5;
		overflow-y: auto;
	}
</style>